<template>
  <div>
    <b-modal
      id="file-thumbnail-modal"
      title="Miniatura File"
      centered
      size="xl"
    >
      <div class="text-center">
        <img :src="url" alt="" class="img-fluid" />
      </div>
      <template #modal-footer>
        <div class="w-100"></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["url"],
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/FileThumbnailDialog.vue